interface ChevronIconProps {
  fill?: string;
}

const ChevronIcon = ({ fill }: ChevronIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M11.5288 5.52864C11.7891 5.26829 12.2111 5.26829 12.4715 5.52864C12.7318 5.78899 12.7318 6.21099 12.4715 6.47134L8.47147 10.4713C8.21112 10.7317 7.78911 10.7317 7.52876 10.4713L3.52876 6.47134C3.26841 6.21099 3.26841 5.78899 3.52876 5.52864C3.78911 5.26829 4.21112 5.26829 4.47147 5.52864L8.00011 9.05728L11.5288 5.52864Z"
        fill={fill ?? "#313131"}
      />
    </svg>
  );
};

export default ChevronIcon;
